import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtTime } from "@/lib/api";
import { PageHeader, Badge } from "@/components/opl/Common";
import { useList, DataTable, GoldBtn } from "@/components/opl/Crud";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Notifications() {
  const [rows, load] = useList("/notifications");
  const [teams] = useList("/teams");
  const [msg, setMsg] = useState("");
  const [team, setTeam] = useState("all");
  const tmap = Object.fromEntries((teams || []).map((t) => [t.id, t.name]));
  const send = async () => {
    try { await api.post("/notifications", { message: msg, team_id: team === "all" ? null : team }); toast.success("Announcement sent"); setMsg(""); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader title="Notifications" crumbs={["Notifications"]} />
      <div className="surface-2 rounded-2xl p-5 mb-6 space-y-3" data-testid="announce-form">
        <p className="eyebrow">Broadcast announcement</p>
        <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Message to LED display, team portals and public updates" data-testid="announce-message-input" />
        <div className="flex flex-wrap gap-2">
          <Select value={team} onValueChange={setTeam}><SelectTrigger className="w-64" data-testid="announce-team-select"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Everyone (public)</SelectItem>{(teams || []).map((t) => <SelectItem key={t.id} value={t.id}>{t.name} only</SelectItem>)}</SelectContent></Select>
          <GoldBtn testid="announce-send-btn" disabled={!msg.trim()} onClick={send}><Send className="h-4 w-4" />Send</GoldBtn>
        </div>
      </div>
      <DataTable rows={rows} testid="notifications-table" columns={[
        { key: "t", label: "Time", render: (r) => <span className="text-xs text-slate-400">{fmtTime(r.created_at)}</span> },
        { key: "type", label: "Type", render: (r) => <Badge className="text-[#F5D061] border-[#E5B842]/30">{r.type}</Badge> },
        { key: "message", label: "Message" }, { key: "to", label: "Audience", render: (r) => (r.team_id ? tmap[r.team_id] : "Everyone") },
      ]} />
    </div>
  );
}
